import React, { useEffect } from 'react';
import { Container } from './styled';
import SoccerMatchRecordStore from './store';
import { useParams } from 'react-router-dom';
import TeamGameStat from './TeamGameStat';
import { observer } from 'mobx-react';

const SoccerSummary = observer(({ gameData }) => {
  const { getAll, data } = SoccerMatchRecordStore();
  let { id } = useParams();

  useEffect(() => {
    getAll('soccer', id);
  }, []);

  return (
    <Container>
      <TeamGameStat data={data} gameData={gameData} />
    </Container>
  );
});

export default SoccerSummary;
